import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import CommandsTable from "./CommandsTable";
import usePermissionCheck from "../../../hooks/usePermissionCheck";
import { FilterLineIcon, PlusIcon } from "../../../components/common/Icons/Icons";

// URL params the filter panel owns (counted on the Filters button)
const filterParams = ['title'];

interface ContainerProps {
  setAddOpen: any;
  setEditOpen: any;
  setDeleteOpen: any;
  setCommandToModify: any;
}

const CommandsContainer: React.FC<ContainerProps> = ({setAddOpen, setEditOpen, setDeleteOpen, setCommandToModify}) => {
  const {canAccess: canCreateApiCommand} = usePermissionCheck(['create_api_command']);
  const [searchParams, setSearchParams] = useSearchParams();

  // Open by default: every filter in view
  const [showFilters, setShowFilters] = useState(true);

  //Filters
  const [title, setTitle] = useState('');

  useEffect(() => {
    setTitle(searchParams.get('title') ?? '');
  }, [searchParams]);

  const handleFilter = () => {
    searchParams.delete('page'); //reset page
    title === "" ? searchParams.delete('title') : searchParams.set('title', title);
    setSearchParams(searchParams);
  };

  const handleClear = () => {
    searchParams.delete('page'); //reset page
    setTitle("");
    searchParams.delete('title');
    setSearchParams(searchParams);
  };

  const activeFilters = filterParams.filter((param) => searchParams.has(param)).length;

  const toolbar = (
    <>
      <button
        type="button"
        className={`btn btn-sm dt-tool-btn lp-filter-toggle ${showFilters ? 'active' : ''}`}
        onClick={() => setShowFilters(!showFilters)}
        aria-expanded={showFilters}
        aria-controls="lp-filters"
      >
        <FilterLineIcon/> Filters
        {activeFilters > 0 && <span className="lp-count">{activeFilters}</span>}
      </button>

      {canCreateApiCommand &&
        <button type="button" className="btn btn-sm btn-primary lp-primary-action" onClick={() => setAddOpen(true)}>
          <PlusIcon/> Add Command
        </button>}
    </>
  );

  return (
    <div className={`lp-layout ${showFilters ? '' : 'filters-hidden'}`}>
      {showFilters && (
        <aside className="lp-filters" id="lp-filters" aria-label="Filters">
          <div className="lp-filters-body">
            <div className="lp-group">
              <TextField
                id="title-search"
                label="Title"
                type="search"
                fullWidth={true}
                value={title ?? ""}
                onChange={(e) => setTitle(e.target.value)}
                onKeyDown={(e) => (e.code === "Enter" ? handleFilter() : null)}
                size="small"
                autoComplete="command-title"
              />
            </div>
          </div>

          <div className="lp-filters-foot">
            <button type="button" className="btn btn-sm lp-clear-btn" onClick={handleClear}>Clear</button>
            <button type="button" className="btn btn-sm btn-primary" onClick={handleFilter}>Apply Filters</button>
          </div>
        </aside>
      )}

      <CommandsTable
        setCommandToModify={setCommandToModify}
        setEditOpen={setEditOpen}
        setDeleteOpen={setDeleteOpen}
        toolbar={toolbar}
      />
    </div>
  );
};

export default CommandsContainer;
